import React from 'react';
import { CardViewContentBlockProps } from './types';
import { Box, Typography } from '@mui/material';
import LibraryCategoryCard from '../../../../common/library-category-card/LibraryCategoryCard';
import { useTranslation } from 'react-i18next';
import TerminationIcon from '../../../../../static/assets/svg/termination.svg';
import PolicyIcon from '../../../../../static/assets/svg/policy.svg';
import ProposalIcon from '../../../../../static/assets/svg/proposal.svg';
import ProjectMaterialsIcon from '../../../../../static/assets/svg/project-materials.svg';
import InvoicingIcon from '../../../../../static/assets/svg/invoicing.svg';
import { TAGS_LABELS } from '../../../../common/constants/tags-labels';
import { ReceiptLong } from '@mui/icons-material';
import { Helpers } from '../../../../common/helpers/helpers';

export const SuppliersCategoryContent = ({ templates, setWorkflow }: CardViewContentBlockProps) => {
  const { t } = useTranslation();
  const templatesFilteredByCategory = [...templates].filter(
    (template) =>
      'dl_workflows' in template && 'is_free' in template && template.category === 'Suppliers'
  );
  const getTemplatesCount = (workflow: string) => {
    return templatesFilteredByCategory.filter((el) => el.dl_workflows.includes(workflow)).length;
  };
  const getFreeTemplatesCount = (workflow: string) => {
    return templatesFilteredByCategory.filter(
      (el) => el.dl_workflows.includes(workflow) && el.is_free
    ).length;
  };
  const getTemplatesCountByWorkflow = (workflow: string) => {
    return templatesFilteredByCategory.filter((el) => el.dl_workflows.includes(workflow)).length;
  };
  const getIcon = (workflow: string) => {
    switch (workflow) {
      case t('tagsLabels.documentWorkflow.supplier.agreement'):
        return <PolicyIcon />;
      case t('tagsLabels.documentWorkflow.supplier.proposalOrQuote'):
        return <ProposalIcon />;
      case t('tagsLabels.documentWorkflow.supplier.projectMaterials'):
        return <ProjectMaterialsIcon />;
      case t('tagsLabels.documentWorkflow.supplier.invoicing'):
        return <InvoicingIcon />;
      case t('tagsLabels.documentWorkflow.supplier.termination'):
        return <TerminationIcon />;
      case t('tagsLabels.documentWorkflow.supplier.receipts'):
        return <ReceiptLong />;
    }
  };

  const getWorkflowNumber = (workflow: string) => {
    switch (workflow) {
      case t('tagsLabels.documentWorkflow.supplier.agreement'):
        return '1. ';
      case t('tagsLabels.documentWorkflow.supplier.receipts'):
        return '2. ';
    }
  };
  return (
    <>
      <Typography
        variant='h3'
        component='h3'
        sx={{ marginBottom: '16px', fontSize: '15px', lineHeight: '24px' }}
      >
        {t('headers.workflows')}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '24px',
          backgroundColor: 'transparent',
          flexWrap: 'wrap',
        }}
      >
        {TAGS_LABELS.documentWorkflow.supplier.map((el) =>
          getTemplatesCountByWorkflow(t(el)) > 0 ? (
            <LibraryCategoryCard
              key={el}
              title={Helpers.capitalizeTitle(getWorkflowNumber(t(el)) + t(el))}
              description={getTemplatesCount(t(el)) + ' templates'}
              hasFreeLabel={getFreeTemplatesCount(t(el)) > 0}
              onClick={() => setWorkflow(t(el))}
              icon={getIcon(t(el))}
            />
          ) : null
        )}
      </Box>
    </>
  );
};
